import { render, staticRenderFns } from "./drag-drop-icon.vue?vue&type=template&id=4f55d298&"
import script from "./drag-drop-icon.vue?vue&type=script&lang=ts&"
export * from "./drag-drop-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f55d298')) {
      api.createRecord('4f55d298', component.options)
    } else {
      api.reload('4f55d298', component.options)
    }
    module.hot.accept("./drag-drop-icon.vue?vue&type=template&id=4f55d298&", function () {
      api.rerender('4f55d298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/matrix-actions/drag-drop-icon/drag-drop-icon.vue"
export default component.exports